import { render, staticRenderFns } from "./SettingInput.vue?vue&type=template&id=d0872fae&lang=html&"
import script from "./SettingInput.vue?vue&type=script&lang=js&"
export * from "./SettingInput.vue?vue&type=script&lang=js&"
import style0 from "./SettingInput.vue?vue&type=style&index=0&id=d0872fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports